'use strict';

module Patersons {
    export class OrderRequest {
        id: number;        
        portfolioId: number;        
        requestDateTime: Date;
        securityCode: string;
        orderAction: string;
        volume: string;
        price: string;        
        buyAtMarketRate: boolean;
        orderNumber: number;       
   }
}